var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlGreenTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 36,
    viewBox: "0 0 31 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4514 27.1211V33.8921H5.74219V36.0007H25.2724V33.8921H16.5633V27.1211H14.4514Z",
    fill: "#2D5E59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5795 19.0882L12.0728 17.5972L14.4471 19.9677V15.3439L10.5796 11.4826L12.0729 9.9916L14.4471 12.362V9.17811H16.5591V16.1649L18.9333 13.7945L20.4266 15.2854L16.5591 19.1468V27.1192H24.9671C28.2971 27.1192 31.0063 24.4144 31.0063 21.0896C31.0063 19.7221 30.5347 18.3827 29.6785 17.3183C29.0886 16.5849 28.3322 15.9998 27.4841 15.6101C27.7136 14.8573 27.8296 14.0755 27.8296 13.2744C27.8296 11.3532 27.1396 9.49363 25.8868 8.03836C24.8324 6.81335 23.4357 5.93668 21.8916 5.51722C21.6929 4.13533 21.0524 2.86063 20.042 1.86271C18.8256 0.661459 17.2137 0 15.503 0C13.7923 0 12.1803 0.661459 10.9642 1.86257C9.95389 2.86049 9.31335 4.13519 9.11461 5.51708C7.57052 5.93654 6.17398 6.81321 5.11943 8.03822C3.86664 9.49349 3.17668 11.353 3.17668 13.2742C3.17668 14.0753 3.29255 14.8572 3.52219 15.61C2.67404 15.9997 1.91762 16.5848 1.32776 17.3181C0.471521 18.3826 0 19.722 0 21.0895C0 24.4142 2.70917 27.1191 6.03917 27.1191H14.4471V22.9495L10.5795 19.0882Z",
    fill: "#2D5E59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlGreenTwo);
export default __webpack_public_path__ + "static/media/al-green-two.3c89d82aabca4ce6cb10831697fa9a84.svg";
export { ForwardRef as ReactComponent };